import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sidebar } from './Dashboard';

const API = 'https://tribaltech-backend.onrender.com';

export default function Review() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('tribal_token');
  const headers = { Authorization: 'Bearer ' + token };

  useEffect(() => {
    axios.get(API + '/api/leaks', { headers })
      .then(r => {
        const needsReview = (r.data || []).filter(l => !l.dmca_filed);
        setItems(needsReview);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const fileDMCA = async (item) => {
    try {
      await axios.post(API + `/api/leaks/${item.id}/dmca`, {}, { headers });
      setItems(items.filter(i => i.id !== item.id));
    } catch (e) {
      alert('DMCA failed: ' + (e.response?.data?.error || e.message));
    }
  };

  const dismiss = (url) => {
    setItems(items.filter(i => i.leaked_url !== url));
  };

  const platform = (url) => {
    try { return new URL(url).hostname.replace('www.',''); }
    catch { return 'Unknown'; }
  };

  const matchColor = (score) => {
    if (!score) return 'var(--muted)';
    if (score >= 90) return '#22C55E';
    if (score >= 70) return '#F59E0B';
    return '#EF4444';
  };

  return (
    <div className="page">
      <Sidebar />
      <div className="main">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <div className="page-title" style={{ marginBottom:0 }}>
            Needs Review
            {items.length > 0 && (
              <span style={{ marginLeft:12, background:'#7F1D1D', color:'#FCA5A5', fontSize:12, padding:'2px 10px', borderRadius:10 }}>
                {items.length} pending
              </span>
            )}
          </div>
        </div>

        <div style={{ marginBottom:20, fontSize:13, color:'var(--muted)' }}>
          These URLs were found by the crawler and need your action. Review each one and file a DMCA or dismiss.
        </div>

        {loading ? (
          <div className="card" style={{ color:'var(--muted)' }}>Loading...</div>
        ) : items.length === 0 ? (
          <div className="card" style={{ textAlign:'center', padding:'40px 0', color:'var(--muted)' }}>
            No items need review. You're all clear.
          </div>
        ) : (
          items.map((item, i) => (
            <div key={i} className="card" style={{ marginBottom:12 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:16 }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
                    <span style={{ fontSize:12, background:'var(--bg3)', padding:'2px 8px', borderRadius:6, color:'var(--muted)' }}>
                      {platform(item.leaked_url)}
                    </span>
                    {item.match_score && (
                      <span style={{ fontSize:12, color: matchColor(item.match_score), fontWeight:600 }}>
                        {item.match_score}% match
                      </span>
                    )}
                    {item.match_method && (
                      <span style={{ fontSize:11, color:'var(--muted)' }}>via {item.match_method}</span>
                    )}
                  </div>
                  <a href={item.leaked_url} target="_blank" rel="noreferrer"
                    style={{ fontSize:13, color:'var(--purple-light)', wordBreak:'break-all' }}>
                    {item.leaked_url}
                  </a>
                  {item.notes && (
                    <div style={{ fontSize:11, color:'var(--muted)', marginTop:4 }}>{item.notes}</div>
                  )}
                  <div style={{ fontSize:11, color:'var(--muted)', marginTop:4 }}>
                    Found: {item.detected_at ? new Date(item.detected_at).toLocaleDateString() : '—'}
                  </div>
                </div>
                <div style={{ display:'flex', gap:8, flexShrink:0, alignItems:'center' }}>
                  {!item.is_safe && !item.needs_review && (
                    <button
                      className="btn btn-danger"
                      style={{ fontSize:12, padding:'6px 12px' }}
                      onClick={() => fileDMCA(item)}
                    >
                      File DMCA
                    </button>
                  )}
                  {item.needs_review && (
                    <span style={{ fontSize:11, padding:'4px 10px', borderRadius:6, background:'#78350F22', color:'#FBBF24', border:'1px solid #FBBF2444' }}>
                      Pending review
                    </span>
                  )}
                  {item.is_safe && (
                    <span style={{ fontSize:11, padding:'4px 10px', borderRadius:6, background:'#1F293722', color:'#9CA3AF', border:'1px solid #9CA3AF44' }}>
                      Not actionable
                    </span>
                  )}
                  <button
                    className="btn btn-secondary"
                    style={{ fontSize:12, padding:'6px 12px' }}
                    onClick={() => dismiss(item.leaked_url)}
                  >
                    Dismiss
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
